import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { CommonModule } from '@angular/common';
import { diffDays } from 'src/app/Services/Utils/utils';

export const CELESTE = 'CELESTE';
export const AMARILLO = 'AMARILLO';
export const NARANJO = 'NARANJO';
export const ROJO = 'ROJO';

type CELESTE = typeof CELESTE;
type AMARILLO = typeof AMARILLO;
type NARANJO = typeof NARANJO;
type ROJO = typeof ROJO;

enum EnumEstadoContadorBanner {
  ACTUALIZAR = 1,
  ACTUALIZA_V2,
  RELOJ,
  EXPIRADO,
}

@Component({
  selector: 'app-contenedor-banner',
  templateUrl: './contenedor-banner.component.html',
  styleUrls: ['./contenedor-banner.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class ContenedorBannerComponent {
  private _contador: string | boolean = false;
  @Input({ required: true })
  public set contador(valor: string | boolean) {
    this._contador = valor;
    if (typeof valor === 'string') {
      setTimeout(() => {
        this.iniciaContador();
      }, 1000);
    }
  }
  public get contador() {
    return this._contador;
  }
  @Input({ required: false }) mensaje: string | null = null;
  @Input({ required: false }) ocultaCierre: boolean = false;
  @Output() pagarEnLinea = new EventEmitter<void>();
  private _colorBanner: CELESTE | AMARILLO | NARANJO | ROJO = CELESTE;
  @Input({ required: false })
  public set colorBanner(valor: CELESTE | AMARILLO | NARANJO | ROJO) {
    this._colorBanner = valor;
    const obtenerEstadoContador = this.obtenerTipoBannerSegunColor(valor);
    this.estadoContador = obtenerEstadoContador;
  }
  public get colorBanner() {
    return this._colorBanner;
  }
  @Input()
  public set forzarCierre(v: boolean) {
    this.ocultaBanner = v;
  }
  @Input()
  public set forzarBloqueoPantalla(valor: boolean) {
    if(valor){
      this.iniciaBloqueoPantalla();
    }
  }
  ocultaBanner: boolean = false;
  tipoEstadoContador = EnumEstadoContadorBanner;
  estadoContador: number | null = null;
  fechaExpiracionEmpresa: number | null = null;
  constructor(private appState: AppStateService) {}

  private iniciaBloqueoPantalla() {
    const elementosPermitidos = [
      document.querySelector('.bar')
      , ...Array.from(document.querySelectorAll('.contenedor_banner'))
    ].filter(Boolean)
    , contenedor = Array.from(document.body.querySelectorAll("*"))
    , contenedorFiltrado = contenedor.filter(nodo => {
      if(nodo.tagName.toLowerCase().startsWith("app-")) return false
      if(nodo.tagName.toLowerCase() === "router-outlet") return false
      return true
    });
    contenedorFiltrado.forEach(hijos =>{
      const permitido = elementosPermitidos.some(nodo => hijos === nodo || nodo?.contains(hijos));
      if(!permitido){
        (hijos as HTMLElement).style.pointerEvents = "none";
        (hijos as HTMLElement).style.filter = 'blur(2px)'
      }
    })
  }

  private iniciaContador(): void {
    const date = this.contador;
    if (typeof date === 'boolean') return;
    const dateAux: string | Date = new Date(date);

    if (dateAux instanceof Date && !isNaN(dateAux.valueOf())) {
      try {
        const { diferenciaEnDias } = diffDays(dateAux),
          limite = Math.trunc(Math.max(0, diferenciaEnDias));

        if (limite > 45) {
          throw new Error('Fecha fuera de rango');
        }
      } catch (error) {
        return;
      }
      this.ocultaBanner = false;
      const expiration = dateAux.getTime();
      this.fechaExpiracionEmpresa = expiration;
      const x = setInterval(() => {
        const { diferenciaPrecisa, diferenciaEnDias } = diffDays(dateAux),
          { dias, horas, minutos, segundos } = diferenciaPrecisa,
          countDown = [
            dias, // days
            horas, //hours
            minutos, // minutes
            segundos, // seconds
          ],
          _dias = Math.trunc(Math.max(0, diferenciaEnDias));

        this.appState.document
          .getElementById('contenedor_contador')
          ?.childNodes.forEach((e: any, key) => {
            e.lastChild.innerHTML = countDown[key];
          });

        if (diferenciaEnDias <= 0) {
          clearInterval(x);
          this.estadoContador = EnumEstadoContadorBanner.EXPIRADO;
        } else if (_dias <= 10) {
          this.estadoContador = EnumEstadoContadorBanner.RELOJ;
        } else if (_dias <= 20) {
          this.estadoContador = EnumEstadoContadorBanner.ACTUALIZA_V2;
        } else if (_dias <= 45) {
          this.estadoContador = EnumEstadoContadorBanner.ACTUALIZAR;
        }
      }, 1000);
    }
  }

  obtenerEstiloBanner(): string | null {
    if (this.ocultaBanner) return null;
    let clase = 'estilo_banner_';
    switch (this.estadoContador) {
      case EnumEstadoContadorBanner.ACTUALIZAR:
        return `${clase}${CELESTE.toLowerCase()}`;

      case EnumEstadoContadorBanner.ACTUALIZA_V2:
        return `${clase}${AMARILLO.toLowerCase()}`;

      case EnumEstadoContadorBanner.RELOJ:
        return `${clase}${NARANJO.toLowerCase()}`;

      case EnumEstadoContadorBanner.EXPIRADO:
        return `${clase}${ROJO.toLowerCase()}`;

      default:
        return null;
    }
  }

  obtenerTipoBannerSegunColor(color: CELESTE | AMARILLO | NARANJO | ROJO) {
    switch (color) {
      case CELESTE:
        return EnumEstadoContadorBanner.ACTUALIZAR;

      case AMARILLO:
        return EnumEstadoContadorBanner.ACTUALIZA_V2;

      case NARANJO:
        return EnumEstadoContadorBanner.RELOJ;

      case ROJO:
        return EnumEstadoContadorBanner.EXPIRADO;

      default:
        return EnumEstadoContadorBanner.ACTUALIZAR;
    }
  }

  onPagarEnLinea(): void {
    this.pagarEnLinea.emit();
  }

}
